import React, { Component } from 'react';
import OpenCloseButton from '../../../ui/OpenCloseButton';

import styles from './videoTeaser.module.scss';

const VideoTeaser = props => {
  // const { url, alt } = images[0];
  // console.log(props);
  return (
    <div className={styles.container}>
      {/* <div className={styles.imageContainer}>
        <div className={styles.imageContainerInner}>
          <img className={styles.image} src={url} alt={alt} />
        </div>
      </div>
      <div className={styles.contentContainer}>
        {title.length && (
          <h4
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {body.legnth && (
          <p
            className={styles.body}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        )}
        <OpenCloseButton onClick={onClick} />
      </div> */}
    </div>
  );
};

export default VideoTeaser;



// WEBPACK FOOTER //
// ./src/components/tour/details/teasers/VideoTeaser.js